/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable @next/next/no-img-element */
import React from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24/ContainerHome24';
import CustomEmblaCarouselHome24 from '../../organisms/CustomEmblaCarouselHome24';
import Styles from './MeuFinanciamentoServicos.css';
import { isMobile } from '@/utils/browser';

function MeuFinanciamentoServicos() {
  return (
    <section id="santander-servicos">
      <ContainerHome24 className="servicos-container">
        <h2 className="text-headline">
          Confira os serviços disponíveis para seu financiamento em nossa Área do Cliente
        </h2>
        <p className="sub-text-headline">
          Para ser direcionado ao serviço desejado, você só precisa clicar em uma das opções abaixo.
        </p>
      </ContainerHome24>

      <ContainerHome24 className="servicos-container">
        <CustomEmblaCarouselHome24
          loop
          enableBullets
          enableMobileArrows
          options={{ slidesToScroll: isMobile() ? 2 : 3 }}
          detectBulletCount
        >
          {({ className }) => (
            <>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=2a-via-de-boletos"
                  target="_blank"
                  rel="noopener"
                  id="servicos-financiamento-de-veiculos"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_barcode.svg"
                    alt="icone boleto"
                    layout="fixed"
                  />

                  <h3>
                    2ª via de
                    <br />
                    boletos
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=emitir-carne"
                  target="_blank"
                  rel="noopener"
                  id="servicos-segunda-via-de-boletos"
                >
                  <img
                    src="assets/meu-financiamento/servicos/Icon.svg"
                    alt="icone carnê"
                    layout="fixed"
                  />
                  <h3>
                    Emitir
                    <br />
                    carnê
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=antecipar-parcelas"
                  target="_blank"
                  rel="noopener"
                  id="servicos-renegociacao-de-dividas"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_calendar.svg"
                    alt="icone parcelas"
                    layout="fixed"
                  />
                  <h3>
                    Antecipar
                    <br />
                    parcelas
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=quitar-contrato"
                  target="_blank"
                  rel="noopener"
                  id="servicos-auto-negocio"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_levy_sent.svg"
                    alt="icone contrato"
                    layout="fixed"
                  />
                  <h3>
                    Quitar
                    <br />
                    contrato
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=renegociar-dividas"
                  target="_blank"
                  rel="noopener"
                  id="servicos-parcele-com-mais-vezes"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_std_financing_reseller.svg"
                    alt="icone dívidas"
                    layout="fixed"
                  />
                  <h3>
                    Renegociar
                    <br />
                    dívidas
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=reorganizar"
                  target="_blank"
                  rel="noopener"
                  id="servicos-financiamento-moto"
                >
                  <img
                    src="assets/meu-financiamento/servicos/Ic_coin.svg"
                    alt="icone reorganizar contrato"
                    layout="fixed"
                  />
                  <h3>
                    Reorganizar <br />
                    (contrato em dia)
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=alterar-forma-de-pagamento"
                  target="_blank"
                  rel="noopener"
                  id="servicos-copia-de-contrato"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_alterar_forma_pagamento.svg"
                    alt="icone forma de pagamento"
                    layout="fixed"
                  />
                  <h3>
                    Alterar forma de <br />
                    pagamento
                  </h3>
                </a>
              </div>
              <div className={`slide ${className}`}>
                <a
                  className="service-card"
                  href="https://www.santanderfinanciamentos.com.br/spa-mktfinweb/#/login?int_source=portalSF&int_medium=consultar-financiamento&int_campaign=comprovante"
                  target="_blank"
                  rel="noopener"
                  id="servicos-copia-de-contrato"
                >
                  <img
                    src="assets/meu-financiamento/servicos/ic_comprovante_pagamento.svg"
                    alt="icone comprovante de pagamento"
                    layout="fixed"
                  />
                  <h3>
                    Comprovante
                    <br />
                    de pagamento
                  </h3>
                </a>
              </div>
            </>
          )}
        </CustomEmblaCarouselHome24>
      </ContainerHome24>
      <img
        className="service-logo"
        src="assets/meu-financiamento/servicos/Santander.svg"
        alt="icone logo santander"
        layout="fixed"
      />

      <style jsx>{Styles}</style>
    </section>
  );
}

export default MeuFinanciamentoServicos;
